import React from 'react';
import { Icon } from './Icon.js';
export const IconOctagonWarning = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16 2L7.99906 2L2 7.99999L2.00012 16.0376L7.99903 22.0366L16 22.0365L22.0366 16.0376L22.0366 7.99894L16 2Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 16H12.01", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 12V8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconOctagonWarning.js.map